type SearchItem = {
  title: string;
  path: string;
  keywords: string[];
};

export const searchData: SearchItem[] = [
  {
    title: "About Planetrus",
    path: "/about-us/about-planetrus",
    keywords: ["about", "company", "mission", "team", "change"],
  },
  {
    title: "Meet Our Team",
    path: "/about-us/meet-our-team",
    keywords: ["team", "members", "leadership", "management"],
  },
  {
    title: "Why Us",
    path: "/why-us",
    keywords: ["benefits", "advantages", "choose", "reasons"],
  },
  {
    title: "Our Commitments",
    path: "/our-commitments",
    keywords: ["commitments", "sustainability", "environment", "quality"],
  },
  {
    title: "Blog",
    path: "/blog",
    keywords: ["blog", "articles", "news", "insights"],
  },
  {
    title: "Used Cooking Oil Recycling",
    path: "/sustainability/used-cooking-oil-recycling",
    keywords: ["recycling", "oil", "cooking", "waste", "sustainable"],
  },
  {
    title: "The Circular Economy",
    path: "/sustainability/the-circular-economy",
    keywords: ["circular", "economy", "sustainability", "future"],
  },
  {
    title: "Contact Us",
    path: "/contact-us",
    keywords: ["contact", "message", "reach", "connect"],
  },
];
